export default __webpack_public_path__ + "static/media/p4.e719e516.png";